import { AxiosResponse } from 'axios'
import { ISupportHistoryListResponse } from '~/src/repositories/SupportHistoryRepository/models/SupportHistoryList'
import { axiosInstance } from '~/src/config/config_axios'

type TPostPayloadType = {
  adminId: number
  userId: number
  message: string
  attachedFiles?: {
    filename: string
    url: string
  }[]
}
export class SupportHistoryRepository {
  async getSupportHistory(id: number): Promise<AxiosResponse<ISupportHistoryListResponse['data']>> {
    return axiosInstance.get(`/support-histories/${id}`)
  }
  async post(data: TPostPayloadType): Promise<void> {
    return axiosInstance.post('/support-histories', data)
  }
}
